/* eslint-disable no-magic-numbers */
import React, { useEffect, useState } from 'react'
import { requestGetSites } from '../api/site'
export const MySiteContext = React.createContext({})

export const MySiteProvider = ({ children }) => {
  const [isMySite, setIsMySite] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [sites, setSites] = useState([])
  const [pagination, setDefaultPaginationState] = useState({
    totalNumber: 0,
    resultsPerPage: 12,
    totalPages: 0,
    currentPage: 1,
    hasNext: true,
    hasPrevious: false
  })
  const [allSiteLength, setAllSiteLength] = useState(0)
  const [mySiteLength, setMySiteLength] = useState(0)
  const [refreshFlag, setRefreshFlag] = useState(false)

  function getSitesCount(mySite) {
    setIsLoading(true)
    requestGetSites({
      resultsPerPage: 12,
      currentPage: 1,
      toggle: mySite
    }).then((data) => {
      return mySite ? setMySiteLength(data?.pagination?.totalNumber || 0) : setAllSiteLength(data?.pagination?.totalNumber || 0)
    })
  }

  function refreshSiteCounts() {
    getSitesCount(true) // get my sites count
    getSitesCount(false) // get all sites count
  }

  function refreshSites() {
    setRefreshFlag(!refreshFlag)
    setRefreshFlag(false)
  }

  const [siteFilters, setSiteFilters] = useState({
    year: '',
    country: '',
    status: ''
  })

  const resetFilters = () => {
    setDefaultPaginationState({
      totalNumber: 0,
      resultsPerPage: 12,
      totalPages: 0,
      currentPage: 1,
      hasNext: true,
      hasPrevious: false
    })
    setSites([])
    setSiteFilters({
      year: '',
      country: '',
      status: ''
    })
  }

  const updateSitesFilters = (filterId, value) => {
    switch (filterId) {
      case 'year':
        setSiteFilters({ year: value, country: siteFilters.country, status: siteFilters.status })
        break

      case 'country':
        siteFilters.country = value
        setSiteFilters({ year: siteFilters.year, country: value, status: siteFilters.status })
        break

      case 'status':
        setSiteFilters({ year: siteFilters.year, country: siteFilters.country, status: value })
        break
      default:
        break
    }
  }

  const updateFilteredSites = (data) => {
    setSites(data)
  }

  useEffect(() => {
    getSitesCount(true)
    getSitesCount(false)
  }, [])

  return (
    <MySiteContext.Provider
      value={{
        isMySite,
        setIsMySite,
        allSiteLength,
        mySiteLength,
        getSitesCount,
        updateSitesFilters,
        siteFilters,
        updateFilteredSites,
        sites,
        resetFilters,
        pagination,
        setDefaultPaginationState,
        isLoading,
        setIsLoading,
        refreshSiteCounts,
        refreshSites,
        refreshFlag
      }}
    >
      {children}
    </MySiteContext.Provider>
  )
}
